module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/pin-2de5146d35afd7912938272c7e3b0ea3.svg";